import moment from "moment";

/** Validate a calendar date without converting it to a timestamp or timezone. */
export const isValidBatchDate = (value: unknown): value is string =>
  typeof value === "string" &&
  /^\d{4}-\d{2}-\d{2}$/.test(value) &&
  moment(value, "YYYY-MM-DD", true).isValid();

/** Purchases can only be recorded for today or an earlier local calendar day. */
export const isValidPurchaseDate = (value: unknown): value is string =>
  isValidBatchDate(value) && value <= moment().format("YYYY-MM-DD");
